import script from "./ServiceInfoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceInfoDetail.vue?vue&type=script&setup=true&lang=js"

import "./ServiceInfoDetail.vue?vue&type=style&index=0&id=708bb528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708bb528"]])

export default __exports__